import { Link } from "react-router-dom";

export const dataDigitalBestSeller = [
    {
      id: 1,
      icon: './images/success.png',
      head: 'Success Stories Of Madhaya Pradesh',
      button: <Link to="/successStory">Read More</Link>
    },
    {
      id: 2,
      icon: './images/success.png',
      head: 'Success Stories Of Madhaya Pradesh',
      button:<Link to="/successStory1">Read More</Link>
    },
    {
      id: 3,
      icon: './images/success.png',
      head: 'Success Stories Of Madhaya Pradesh',
      button:<Link to="/successStory2">Read More</Link>
    },
    {
      id: 4,
      icon: './images/success.png',
      head: 'Success Stories Of Uttarakhand',
      button:<Link to="/successStory3">Read More</Link>
    },
    {
      id: 5,
      icon: './images/success.png',
      head: 'Success Stories Of Andhra Pradesh',
      button:<Link to="/successStory4">Read More</Link>
    },
    {
      id: 6,
      icon: './images/success.png',
      head: 'Success Stories Of Assam',
      button:<Link to="/successStory5">Read More</Link>
    },
    {
      id: 7,
      icon: './images/success.png',
      head: 'Success Stories Of Haryana',
      button:<Link to="/successStory6">Read More</Link>
    },
    {
      id: 8,
      icon: './images/success.png',
      head: 'Success Stories Of Punjab',
      button:<Link to="/successStory7">Read More</Link>
    },
    {
      id: 9 ,
      icon: './images/success.png',
      head: 'Success Stories Of Rajasthan ',
      button:<Link to="/successStory8">Read More</Link>
    },
  ];